import { Flex } from "@chakra-ui/react";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import { useRouter } from "next/router";
import type { AhPlusPricingPlansCard } from "../AhPlusPricingPlans.d";
import { contentStyles } from "./PlanBox.style";
import { updateContent } from "./PlanBox.utils";

export const PlanBox = ({
  content,
  planType,
}: {
  content: AhPlusPricingPlansCard["content"];
  planType: AhPlusPricingPlansCard["planType"];
}) => {
  const { query } = useRouter();
  const updatedContent = updateContent(planType, query, content);

  return (
    <Flex
      bg="white"
      alignSelf={{ base: "center", md: "unset" }}
      w="full"
      maxW="400px"
      rounded="xl"
      direction="column"
      sx={contentStyles}
    >
      {!isEmpty(updatedContent) && <RichtextAdapter content={updatedContent} />}
    </Flex>
  );
};
